import { Col, Row } from "react-bootstrap";
import { Avatar, RatingStars } from "components";

export default function UserReviewItem({
  name,
  image,
  comment,
  time,
  rate,
  renderDivider,
}) {
  return (
    <>
      <Row>
        <Col xl={5} lg={5} md={12} sm={12} xs={12}>
          <Row>
            <Col
              xl={2}
              lg={0}
              md={0}
              sm={0}
              xs={0}
              className="d-none d-xl-block"
            ></Col>
            <Col xl={4} lg={5} md={2} sm={3} xs={4}>
              <Avatar image={image} />
            </Col>
            <Col xl={6} lg={7} md={10} sm={9} xs={8}>
              <h4 className="fw-bold text-black">{name}</h4>
              <p className="fw-medium text-light4">{time}</p>
              <div>
                <RatingStars rate={rate} />
              </div>
            </Col>
          </Row>
        </Col>
        <Col
          xl={7}
          lg={7}
          md={12}
          sm={12}
          xs={12}
          className="text-light5 mt-lg-0 mt-4"
        >
          <p className="fw-normal text-light5">{comment}</p>
        </Col>
      </Row>
      {renderDivider && <hr className="mt-4 mt-4 mt-4  mb-4  bg-light4" />}
    </>
  );
}
